module.exports = __webpack_public_path__ + "img/gasbot-side-top.55661db8.webp";